import MNumpad from './index.vue';

MNumpad.install = app => {
  app.component(MNumpad.name, MNumpad);
};

export default MNumpad;
